import { showComment } from '../../containers/RetailerAPI/SelectBrands';
import { toast } from 'react-toastify';
import InfoTooltip from '../InfoTooltip/InfoTooltip';

const ManufacturerItem = ({ manufacturer, selectedIds, handleSelect }) => {
    const isSelected = selectedIds.includes(manufacturer.id);

    const handleImageError = event => {
        event.currentTarget.onerror = null;
        if (['edap_sm', 'thing_charge_amps', 'dummy'].includes(manufacturer.id)) {
            return;
        }
        toast.warning(`Missing brand logo: ${manufacturer.label}.`, {
            toastId: `missing-logo-${manufacturer.id}`,
            autoClose: 3000,
            closeOnClick: true,
            pauseOnHover: true,
        });
    };

    return (
        <div
            className={`select-manufacturers__brand-item ${!isSelected ? 'select-manufacturers__brand-item--unselected' : ''}`}
            onClick={() => handleSelect(manufacturer.id)}
        >
            <div className="select-manufacturers__brand-item--left">
                <input
                    type="checkbox"
                    name="manufacturer"
                    id={`manufacturer-${manufacturer.id}`}
                    checked={isSelected}
                    onChange={() => handleSelect(manufacturer.id)}
                    onClick={e => e.stopPropagation()}
                />
                <label htmlFor={`manufacturer-${manufacturer.id}`} onClick={e => e.stopPropagation()}>
                    {manufacturer.label.toUpperCase()}
                </label>
                {manufacturer.state !== 'stable' && manufacturer.comment && manufacturer.comment !== '' && (
                    <InfoTooltip tooltip={showComment(manufacturer)} />
                )}
            </div>
            <div className="select-manufacturers__brand-item--right">
                <img
                    className="select-manufacturers__brand-item--brand-logo"
                    src={manufacturer.logo_url}
                    alt={manufacturer.label}
                    onError={handleImageError}
                />
            </div>
        </div>
    );
};

export default ManufacturerItem;
